export const statConstants = {
    GET_AGENTS_PERF_REQUEST: 'GET_AGENTS_PERF_REQUEST',
    GET_AGENTS_PERF_SUCCESS: 'GET_AGENTS_PERF_SUCCESS',
    GET_AGENTS_PERF_FAILURE: 'GET_AGENTS_PERF_FAILURE',

    GET_TODAY_STATS_REQUEST: 'GET_TODAY_STATS_REQUEST',
    GET_TODAY_STATS_SUCCESS: 'GET_TODAY_STATS_SUCCESS',
    GET_TODAY_STATS_FAILURE: 'GET_TODAY_STATS_FAILURE',
};